import loadable from '@loadable/component';

import { CmsApiThreeSectionSliderBlockData } from 'modules/cms/api/types/blocks/CmsApiThreeSectionSliderBlock';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from 'modules/cms/mappers/CmsMappedBlockWidth';
import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

export const CmsThreeSectionSliderBlockMapping: CmsBlockMapping<CmsApiThreeSectionSliderBlockData> =
  {
    invariant: [
      {
        prop: 'headline',
        msg: 'Heading required for Three Section Slider',
      },
      {
        prop: 'sections',
        msg: 'Sections required for Three Section Slider',
      },
    ],
    width: CmsMappedBlockWidth.NARROW,
    Component: hydrateOnDemand(
      loadable(() => import('./CmsThreeSectionSliderBlock'), {
        resolveComponent: (module) => module.CmsThreeSectionSliderBlock,
      }),
    ),
  };
